import React from 'react';
import PropTypes from 'prop-types';
import { QuestionIcon, AlertIcon } from '@domain-group/fe-co-icon';
import { RowButton } from '@domain-group/fe-co-allhomes-design-system';
import { MIN_QUERY_LENGTH } from '../../utils/constants';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Messages = _ref => {
  var error = _ref.error,
    loading = _ref.loading,
    notFoundText = _ref.notFoundText,
    queryText = _ref.queryText;
  if (loading) {
    return ___EmotionJSX(RowButton, {
      title: "Searching...",
      collapse: true
    });
  }
  if (error) {
    return ___EmotionJSX(RowButton, {
      leftIcon: ___EmotionJSX(AlertIcon, null),
      title: "Something went wrong, please try again",
      collapse: true
    });
  }
  if (queryText.length >= MIN_QUERY_LENGTH) {
    return ___EmotionJSX(RowButton, {
      leftIcon: ___EmotionJSX(QuestionIcon, null),
      title: notFoundText,
      collapse: true
    });
  }
  return null;
};
Messages.propTypes = {
  error: PropTypes.bool,
  loading: PropTypes.bool,
  queryText: PropTypes.string,
  notFoundText: PropTypes.string
};
Messages.defaultProps = {
  error: false,
  loading: false,
  queryText: '',
  notFoundText: 'Sorry, no suggestions for that search'
};
export default Messages;